// -
import React from 'react';
import classNames from 'classnames';
import AbstractReactComponent from "../AbstractReactComponent";

import "./ActionsRow.scss";

/**
 * Komponenta řádku detailu, který má akce, může obsahovat i celý obsah panelu, nebo být použit např. na část s akcemi nebo nadpis s akcemi.
 */
class ActionsRow extends AbstractReactComponent {
    // TODO [R: dokumentace]
    static propTypes = {
        // actions:   // akce
        // children: label
        // noCenter - pokud je true, centruji se obsay vertikalne
        // visibleActions - pokud je true, jsou akce vidět vždy, jinak pouze na hover
    };

    render() {
        const {visibleActions, noCenter, actions, children, className, ...other} = this.props;

        const wrapperClassNames = classNames(
            className,
            "action-row-container",
            {
                "center-items": !noCenter,
                "actions-visible": visibleActions,
                "actions-hover": !visibleActions
            }
        );

        return <div className={wrapperClassNames} {...other}>
            <div className="action-row-label">{children}</div>
            <div className="action-row-actions">{actions}</div>
        </div>
    }
}

export default ActionsRow;
